import React from 'react';
import { Eye } from 'lucide-react';
import EnhancedTable from '../../components/common/EnhancedTable';
import { formatTextWithLinks } from '../../utils/formatters';
import '../../components/common/EnhancedTable/EnhancedTableFix.css';
import type { Applicant } from '../../types/applicant';

interface ApplicantTableProps {
  applicants: Applicant[];
  onViewDetails: (applicant: Applicant) => void;
}

export default function ApplicantTable({ applicants, onViewDetails }: ApplicantTableProps) {
  if (!applicants || applicants.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        No applicants found matching your criteria
      </div>
    );
  }

  return (
    <EnhancedTable
      columns={[
        { 
          id: 'view', 
          header: 'View', 
          accessor: (row) => (
            <button
              onClick={() => onViewDetails(row)}
              className="text-primary hover:text-primary-dark"
            >
              <Eye className="h-5 w-5" />
            </button>
          ),
          width: 'narrow',
          align: 'center'
        },
        { 
          id: 'name', 
          header: 'Name',
          accessor: (row) => (
            <div className="truncate" title={row.appl_name || '-'}>
              {formatTextWithLinks(row.appl_name || '-')}
            </div>
          ),
          width: 'medium'
        },
        { 
          id: 'contact_name', 
          header: 'Contact Name',
          accessor: (row) => (
            <div className="truncate" title={row.appl_cont_name || '-'}>
              {formatTextWithLinks(row.appl_cont_name || '-')}
            </div>
          ),
          width: 'medium'
        },
        { 
          id: 'phone', 
          header: 'Phone',
          accessor: (row) => (
            <div className="truncate" title={row.appl_phone || '-'}>
              {formatTextWithLinks(row.appl_phone || '-')}
            </div>
          ),
          width: 'medium'
        },
        { 
          id: 'email', 
          header: 'Email',
          accessor: (row) => (
            <div className="truncate" title={row.appl_email || '-'}>
              {formatTextWithLinks(row.appl_email || '-')}
            </div>
          ),
          width: 'medium'
        },
        { 
          id: 'abbreviation', 
          header: 'Abbreviation',
          accessor: (row) => (
            <div className="truncate" title={row.appl_abbr || '-'}>
              {formatTextWithLinks(row.appl_abbr || '-')}
            </div>
          ),
          width: 'narrow'
        },
        { 
          id: 'id', 
          header: 'ID',
          accessor: (row) => row.appl_id,
          width: 'narrow'
        }
      ]}
      data={applicants}
      keyField="appl_id"
      width="1500px"
      maxHeight="calc(100vh - 16rem)"
      horizontalScroll={true}
      className="enhanced-table-force-scroll"
      emptyMessage="No applicants found matching your criteria"
    />
  );
}
